import classNames from 'classnames/bind';
import styles from './EditCv.module.scss';
import PageTitle from '~/component/PageTitle';
import CvForm from '~/component/Form/CvForm';
import { useContext, useEffect, useRef, useState } from 'react';
import { getData, postData } from '~/helper/apiService';
import { ToastContext } from '~/component/Context/ToastProvider';
import useMeta from '~/hooks/useMeta';

const cx = classNames.bind(styles);

function EditCv() {
  const [cvInfo, setCvInfo] = useState({});
  const [formKey, setFormKey] = useState(1);
  const imgRef = useRef();
  const { addToast } = useContext(ToastContext);
  const loadData = async () => {
    const res = await getData('/cv/read');
    setCvInfo(res[0]);
  };

  useEffect(() => {
    loadData();
  }, []);

  const handleSubmit = async(e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    
    const res = await postData("/cv/update", formData);
    if(res.status === "success"){
      setFormKey(prev=>prev + 1);
      loadData();
    }
  };

  useMeta({
    title: 'Sửa CV - Ngô Gia Quyến | Chỉnh sửa và cập nhật hồ sơ cá nhân',
    description: 'Trang chỉnh sửa CV cá nhân, nơi bạn có thể cập nhật và cải thiện hồ sơ, thông tin nghề nghiệp của mình. Chỉnh sửa thông tin về kinh nghiệm làm việc, kỹ năng và học vấn.',
    keywords: 'sửa CV, chỉnh sửa hồ sơ cá nhân, cập nhật thông tin nghề nghiệp, CV, hồ sơ cá nhân, kỹ năng, kinh nghiệm làm việc',
    author: 'Ngô Gia Quyến',
    url: 'https://ngogiaquyen.id.vn/edit-cv', // Thay bằng URL trang sửa CV của bạn
  });

  return (
    <div className={cx('wrapper')}>
      <PageTitle>edit cv page</PageTitle>
      <div className={cx('container')}>
        <CvForm keyForm={formKey} data={cvInfo} fileInputRef={imgRef} handleSubmit={handleSubmit} />
      </div>
    </div>
  );
}

export default EditCv;
